import React from "react";
import Label from "../atoms/Label";
import { markdownToJSX } from "../../util/transforms";
import * as breakpoints from "../util/breakpoints";
import useMediaQuery from '../util/useMediaQuery'

export default ({ label, title, intro }) => {
    const isMediumUp = useMediaQuery({ minWidth: breakpoints.MEDIUM });

    return (
        <section
            className={ "u-container u-container--medium u-section-spacing " + (isMediumUp ? " u-center-text" : "") }>
            <Label text={ label }/>
            <h2>{ markdownToJSX(title) }</h2>
            <p className="a-preamble">{ intro }</p>
        </section>
    )
}
